document.addEventListener("click", (e) => {
    let ripple = document.createElement("div");
    ripple.style.position = "absolute";
    ripple.style.zIndex = "9999";
    ripple.style.width = "20px";
    ripple.style.height = "20px";
    ripple.style.background = "white";
    ripple.style.borderRadius = "50%";
    ripple.style.pointerEvents = "none";
    ripple.style.opacity = "0.5";
    ripple.style.left = `${e.clientX - 10}px`;
    ripple.style.top = `${e.clientY - 10}px`;
    ripple.style.transform = "scale(2)";
    ripple.style.transition = "transform 0.4s ease-out, opacity 0.4s ease-out";
    
    document.body.appendChild(ripple);

    requestAnimationFrame(() => {
        ripple.style.transform = "scale(5)";
        ripple.style.opacity = "0";
    });

    setTimeout(() => {
        ripple.remove();
    }, 400);
});
